<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros-validacao-baixas ref="validacaoBaixasParams" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-validacao-baixas"
            color="green"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvarValidacaoBaixas()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import ValidacaoBaixasService from '@/services/ValidacaoBaixasService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    name: 'ValidacaoBaixasEdit',

    components: {
      ParametrosValidacaoBaixas: () => import('@/components/validacaoBaixas/ParametrosValidacaoBaixas.vue')
    },

    mixins: [tourMixins],

    data() {
      return {
        loading: false,
        arrTour: [
          {
            element: '#titulo-validacao-baixas',
            intro: 'Aqui você poderá inserir um nome para seu relatório de Validação de Baixas.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#periodo-imobilizacao-validacao-baixas',
            intro: 'Selecione o período de imobilização que será aplicado na base.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#btn-save-validacao-baixas',
            intro:
              'Após seleção dos critérios anteriores, clique aqui para salvar e executar seu relatório de Validação de Baixas.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },
    mounted() {
      this.iniciarTourPagina();
    },

    methods: {
      salvarValidacaoBaixas() {
        this.loading = true;

        const data = this.$refs.validacaoBaixasParams.exportData();

        ValidacaoBaixasService.salvarValidacaoBaixas(data)
          .then(() => {
            this.$router.push({ name: 'Validação de Baixas Histórico' });
            this.$toast.success('Validação de Baixas salva com sucesso.', '', { position: 'topRight' });
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao salvar Validação de Baixas.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>